// extracted by mini-css-extract-plugin
export const card = "card-module--card--3fnRF";
export const isSelectable = "card-module--isSelectable--_5NiD";
export const isSelected = "card-module--isSelected--3ngEw";